import jstz from "jstz";

export enum Interval {
  Day = "day",
}

export enum DateFormat {
  Date = "ddd, MM/DD/YYYY",
  DateTime = "ddd, MMM D, YYYY, hh:mm A",
  DateWithoutDayOfTheWeek = "DD MMM YYYY",
  DateStartedFromMonth = "MMMM DD, YYYY",
  HtmlInputDate = "YYYY-MM-DD",
  Time = "hh:mm:ss a",
  TimeWithoutSeconds = "hh:mm A",
  ShortDate = "D MMM YYYY",
  ChartDailyLabel = "MMM D",
  DateWithoutYear = "MMM DD",
  ChartMonthlyLabel = "MMM'YY",
  ChartDailyRangeLabel = "DD MMM'YY",
  Weekday = "ddd, D MMM",
  ISO = "YYYY-MM-DD[T]HH:mm:ssZZ",
  MonthDayFullYear = "MMM DD, YYYY",
  FullMonthYear = "MMMM YYYY",
  MonthDayYearTime = "MMM D, YYYY, h:mm:ss A", //Feb 6, 2024, 12:01:12 PM
}

export const timezone = jstz.determine().name();
